export const UPDATE_ORG = 'UPDATE_ORG';

export const updateOrg = org => dispatch => {
  dispatch(updateOrgDispatch(org));
};

export const updateOrgDispatch = org => ({
  type: UPDATE_ORG,
  org,
});
